/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {
  const processQuantityChange = function(target, url, product_id) {

    const availabilityAddon = $(target+" .availability_addon");
    const quantityField = $(target+" .quantity-selection-field");

    const originalQuantity = quantityField.val();

    quantityField.html("<i class='fa-solid fa-circle-notch fa-spin' aria-hidden='true'></i>");

    const ajaxConfig = {
      type: "POST",
      dataType: "json",
      url,
      data: { 
        purchase_order_item: {
          quantity: originalQuantity,
          product_id
        }
      },
      success(data, textStatus) {
        if (textStatus==="notmodified") {
          quantityField.val(originalQuantity);
          return;
        }

        availabilityAddon.replaceWith(data.purchase_order_item.availability_addon);
        return quantityField.val(data.purchase_order_item.quantity);
      }
    };

    return $.ajax(ajaxConfig);
  };

  $(document).on("click", ".result.btn-stepper", function(event) {
    const target = $(this).data("target-element");
    const product_id = $(this).data("product-id");
    const url = $(this).data("url");
    event.preventDefault();
    return processQuantityChange(target, url, product_id);
  });
  
  $(document).on("keypress", ".quantity-selection-field", function(event) {
    if (event.which === 13) {
      event.preventDefault();
      
      const target = $(this).data("target-element");
      const product_id = $(this).data("product-id");
      const url = $(this).data("url");
      return processQuantityChange(target, url, product_id);
    }
  });
});  